<template>
    <div class="upload">
        <ul class="upload-tabs">
            <template v-if="$route.query.id">
                <span class="upload-tabs__item active" v-for="(tab, index) in tabsList" :key="index">
                    {{ tab.title }}
                </span>
            </template>
            <template v-else>
                <router-link v-for="(tab, index) in tabsList" :key="index" class="upload-tabs__item" tag="li" :to="tab.type">
                    {{ tab.title }}
                    <span v-if="tab.title === '导入文章'" class="upload-tabs__item_tip">目前支持公众号导入</span>
                </router-link>
            </template>
            
        </ul>
        <div class="upload-vip-tip" v-if="!['UploadCase', 'ImportMaterial'].includes($route.name) && userInfo && userInfo.state === 2">
            <svg-icon icon-class="vip" class-name="icon-vip"></svg-icon>
            <span>你是平台特邀嘉宾，发布无需审核</span>
        </div>
        <router-view v-if="userInfo"></router-view>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Upload',
    data: () =>  ({
        tabsList: []
    }),
    watch: {
        userInfo: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.getTabs();
                }
            }
        },
        '$route.query':{
            deep: true,
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.getTabs();
                }
            }
        }
    },
    computed: {
        ...mapState('user', ['userInfo'])
    },
    methods: {
        getTabs() {
            const { path, query:{id} } = this.$route;
            let tabs = []
            if (id) {
                if (path === '/upload/works') {
                    tabs = [{
                        type: 'works',
                        title: '修改作品'
                    }]
                }
                if (path === '/upload/experience') {
                    tabs = [{
                        type: 'experience',
                        title: '修改经验'
                    }]
                }
                if (path === '/upload/import') {
                    tabs = [{
                        type: 'import',
                        title: '修改文章'
                    }]
                }
            } else {
                tabs = [
                    {
                        type: 'works',
                        title: '上传作品'
                    },
                    {
                        type: 'experience',
                        title: '上传经验'
                    },
                    // {
                    //     type: 'import',
                    //     title: '导入文章'
                    // }
                ];
                if (this.userInfo && this.userInfo.projectPriv) {
                    tabs.splice(1, 0, {
                        type: 'case',
                        title: '上传企业案例'
                    });
                }
                if (this.$route.path === '/upload/material') {
                    tabs = [{
                        type: 'material',
                        title: '素材投稿'
                    }];
                }
            }
            this.tabsList = tabs;
        },
    }
};
</script>

<style lang="scss" scoped>
.upload {
    position: relative;

    .upload-vip-tip {
        position: absolute;
        top: 55px;
        right: 0;
        @include font(#E84C82, 12px, 700);

        .icon-vip {
            margin-right: 4px;
        }
    }

    &-tabs {
        display: flex;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(224, 228, 247, 1);

        &__item {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 28px;
            padding: 0 12px;
            border-radius: 14px;
            @include font(rgba(113, 119, 152, 1), 16px, 400);
            cursor: pointer;

            &:not(:first-child) {
                margin-left: 18px;
            }

            &:hover {
                @include font(rgba(47, 84, 235, 1), 16px, 400);
            }

            &.active {
                background-color: rgba(47, 84, 235, 1);
                color: #fff;

                &:hover {
                    color: #fff;
                }
            }
            &_tip {
                position: absolute;
                right: -135px;
                top: -50%;
                padding: 5px 8px 5px 13px;
                background: rgba(95, 224, 204, 1);
                border-radius: 10px 4px 4px 0;
                color: #fff;
                font-size: 12px;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .upload {
        .upload-vip-tip {
            top: 35px;
        }

        &-tabs {
            padding-bottom: 15px;

            &__item {
                height: 21px;
                padding: 0 9px;
                border-radius: 11px;
                @include font(rgba(113, 119, 152, 1), 14px, 400);

                &:not(:first-child) {
                    margin-left: 14px;
                }

                &:hover {
                    @include font(rgba(47, 84, 235, 1), 14px, 400);
                }
            }
        }
    }
}
</style>
